module.exports = __webpack_public_path__ + "static/feeln-6574c8c2b8df6a95351f0e925302c340.png";